import React from "react";
import PropTypes from "prop-types";

import TagPill from "../../../components/pills/TagPill";

function getDiscountCodeTypeName(type) {
    switch(type) {
        case "coupon": return "Coupon";
        case "voucher": return "Voucher";
        case "promocode": return "Promocode";
        default: return "Onbekend";
    }
}

function getDiscountCodeTypeColor(type) {
    switch(type) {
        case "coupon": return "#1F6BDE";
        case "voucher": return "#FF5000";
        case "promocode": return "#00B506";
        default: return "#595959";
    }
}

function DiscountCodeTypePill({ type, light = false }) {
    const name = getDiscountCodeTypeName(type);
    if(light) {
        return (
            <TagPill variant="light">{ name }</TagPill>
        )
    }
    const color = getDiscountCodeTypeColor(type);
    return (
        <TagPill color={ color }>{ name }</TagPill>
    )
}
DiscountCodeTypePill.propTypes = {
    type: PropTypes.string.isRequired,
    light: PropTypes.bool
}

export default React.memo(DiscountCodeTypePill);
